<template>
  <div class="widget-contact-info-wrapper">
    <!--    <div v-if="(data.type || {}).key === 'button'" class="submit-btn-wrapper">-->
    <!--      <button class="submit-btn">{{ source.button }}</button>-->
    <!--    </div>-->
    <!--    <div v-else class="form-wrapper">-->
    <!--      <h3 class="header">{{ source.title }}</h3>-->
    <!--      <p class="tips">{{ source.description }}</p>-->
    <!--      <el-form-->
    <!--        ref="form"-->
    <!--        :model="form"-->
    <!--        :rules="rules"-->
    <!--        class="contact-info-form"-->
    <!--      >-->
    <!--        <el-form-item prop="company">-->
    <!--          <el-input-->
    <!--            v-model="form.company"-->
    <!--            class="form-input"-->
    <!--            placeholder="请填写所属公司"-->
    <!--          ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item prop="name">-->
    <!--          <el-input-->
    <!--            v-model="form.name"-->
    <!--            class="form-input"-->
    <!--            placeholder="请填写自己真实姓名"-->
    <!--          ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item prop="phone">-->
    <!--          <el-input-->
    <!--            v-model.number="form.phone"-->
    <!--            class="form-input"-->
    <!--            placeholder="输入手机号"-->
    <!--            maxlength="11"-->
    <!--          ></el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item prop="captcha">-->
    <!--          <el-input-->
    <!--            id="captcha"-->
    <!--            v-model="form.captcha"-->
    <!--            class="form-input"-->
    <!--            placeholder="输入右侧验证码"-->
    <!--            maxlength="4"-->
    <!--          >-->
    <!--            <template slot="append">-->
    <!--              <label class="captcha-image" @click="onCaptchaImgClick">-->
    <!--                <img :src="captchaImgSrc" />-->
    <!--              </label>-->
    <!--            </template>-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->
    <!--        <el-form-item prop="code">-->
    <!--          <el-input-->
    <!--            id="code"-->
    <!--            v-model.trim="form.code"-->
    <!--            class="form-input"-->
    <!--            placeholder="请输入手机验证码"-->
    <!--            maxlength="4"-->
    <!--          >-->
    <!--            <template slot="append">-->
    <!--              <label class="code-btn" @click="sendCode">-->
    <!--                <b v-if="codebtnCount === 60">发送动态密码</b>-->
    <!--                <span v-else>{{ codebtnCount }}s后重试</span>-->
    <!--              </label>-->
    <!--            </template>-->
    <!--          </el-input>-->
    <!--        </el-form-item>-->
    <!--      </el-form>-->
    <!--      <button class="submit-btn" :disabled="isSubmitting" @click="onSubmit">-->
    <!--        {{ source.button }}-->
    <!--      </button>-->
    <!--    </div>-->
  </div>
</template>

<script>
import { Message } from 'element-ui'
import { ABS_PATH, THIRD_API } from '@/global/config'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    const validatePhone = (rule, value, callback) => {
      if (/^1\d{10}$/.test(value)) {
        callback()
      } else {
        callback(new Error('手机号码格式错误'))
      }
    }
    const validateCaptcha = (rule, value, callback) => {
      if (/^[a-zA-Z0-9]{4}$/.test(value)) {
        callback()
      } else {
        callback(new Error('验证码错误'))
      }
    }
    const validateCode = (rule, value, callback) => {
      if (/^\d{4}$/.test(value)) {
        callback()
      } else {
        callback(new Error('动态密码错误'))
      }
    }
    return {
      captchaImgSrc: ABS_PATH.captchaImg + '?t=' + +new Date(),
      form: {
        company: '',
        name: '',
        phone: '',
        captcha: '',
        code: ''
      },
      rules: {
        company: [{ max: 30, message: '公司名称不能大于30个字符' }],
        name: [{ max: 30, message: '姓名不能超过30个字符' }],
        phone: [
          {
            required: true,
            validator: validatePhone,
            trigger: 'blur',
            type: 'number'
          }
        ],
        captcha: [
          {
            required: true,
            validator: validateCaptcha,
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            validator: validateCode,
            trigger: 'blur'
          }
        ]
      },
      codebtnCount: 60,
      codebtnCountId: 0,
      isSubmitting: false
    }
  },
  computed: {
    source() {
      const {
        source: {
          description = '留下您的信息，我们会有资深营销顾问与您联系，一对一为您解决营销难题',
          title = '马上注册案例',
          button = '提交注册',
          success = '提交成功',
          trace = ''
        }
      } = this.data
      return { description, title, button, success, trace }
    }
  },
  methods: {
    onCaptchaImgClick() {
      this.updateCaptcha()
      this.form.captcha = ''
    },
    updateCaptcha() {
      this.captchaImgSrc = ABS_PATH.captchaImg + '?t=' + +new Date()
    },
    async sendCode() {
      let isValid = true
      this.$refs.form.validateField(['phone', 'captcha'], message => {
        isValid = !message
      })
      if (isValid && !this.codebtnCountId) {
        try {
          await this.$api.alkSendCode(
            {
              params: {
                phone: this.form.phone,
                validate: this.form.captcha
              }
            },
            true
          )
          this.startCount()
        } catch ({ error }) {
          this.updateCaptcha()
          Message.error(error)
        }
      }
    },
    // 开始倒计时
    startCount() {
      this.codebtnCountId = setInterval(() => {
        if (this.codebtnCount-- <= 0) {
          this.stopCount()
        }
      }, 1000)
    },
    // 结束倒计时
    stopCount() {
      clearInterval(this.codebtnCountId)
      this.codebtnCountId = 0
      this.codebtnCount = 60
    },
    onSubmit() {
      this.$nextTick(() => {
        this.$refs.form.validate(async valid => {
          if (valid) {
            try {
              this.isSubmitting = true
              await this.$http.post(
                THIRD_API.alkPassportSignup.link,
                {
                  params: {
                    phone: this.form.phone,
                    code: this.form.code,
                    name: this.form.name,
                    company: this.form.company,
                    scrm_source: this.source.trace
                  }
                },
                true
              )
              this.isSubmitting = false
              Message.success(this.source.success)
            } catch ({ error }) {
              Message.error(error)
              this.isSubmitting = false
            }
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.widget-contact-info-wrapper {
  margin: 16px 0;
  text-align: center;
  display: none;
  .form-wrapper {
    width: 408px;
    background-color: #f4f5f7;
    border-radius: 8px;
    padding: 32px 64px 48px;
    margin: 0 auto;
    box-sizing: border-box;
    .submit-btn {
      width: 100%;
      margin-bottom: 12px;
    }
  }
  .header {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
  }
  .tips {
    font-size: 14px;
    margin-bottom: 20px;
  }
  .submit-btn {
    padding: 0 5em;
    height: 48px;
    text-align: center;
    color: #ffffff;
    background-color: #3352fe;
    border: none;
    outline: none;
    cursor: pointer;
    border-radius: 24px;
    white-space: nowrap;
  }
  .notes {
    text-align: center;
    font-size: 12px;
    color: #8e9091;
    a {
      font-size: 12px;
      color: #3352fe;
    }
  }
  .captcha-image {
    width: 104px;
    height: 38px;
    overflow: hidden;
    display: block;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      float: left;
    }
  }
  .code-btn {
    width: 120px;
    height: 38px;
    line-height: 38px;
    text-align: center;
    position: relative;
    font-size: 13px;
    color: #8e9091;
    display: block;
    cursor: pointer;
    background-color: #ffffff;
    &:before {
      content: '';
      position: absolute;
      top: 6px;
      bottom: 6px;
      left: 0;
      width: 1px;
      background-color: #fafafb;
    }
    b {
      font-weight: bold;
      color: #3352fe;
    }
  }
}
</style>

<style lang="scss">
.widget-contact-info-wrapper {
  color: #363636;
  .el-input__inner {
    border-radius: 20px;
    font-size: 16px;
    border-color: #f4f5f7;
    background-color: #ffffff;
    color: #363636;
    padding: 0 20px;
    &::placeholder {
      font-size: 13px;
      color: #8e9091;
    }
    &:focus {
      &,
      & + .el-input-group__append {
        border-color: #3352fe;
      }
    }
  }
  .el-form-item.is-error {
    .el-input-group__append {
      border-color: #f8653f;
    }
  }
  .el-input-group--append {
    .el-input__inner {
      border-radius: 20px 0 0 20px;
      border-right: none;
    }
    .el-input-group__append {
      border-radius: 0 20px 20px 0;
      background-color: transparent;
      border-color: #f4f5f7;
      padding: 0;
      overflow: hidden;
    }
  }
}
</style>
